const FORMATS = {
  mmyyyy_slash: 'mmddyyyy_slash',
  mmddyyyy_slash: 'mmddyyyy_slash',
  mmddyyyy_dash: 'mmddyyyy_dash',
  ddmmyyyy_slash: 'ddmmyyyy_slash',
  ddmmyyyy_dash: 'ddmmyyyy_dash',
  yyyymmdd_slash: 'yyyymmdd_slash',
  yyyymmdd_dash: 'yyyymmdd_dash',
};

const FORMATS_CONFIG = {
  mmyyyy_slash: {
    dateFns: 'MM/yyyy',
    placeholder: 'MM/YYYY',
    cleave: {
      date: true,
      delimiter: '/',
      datePattern: ['m', 'Y'],
    },
  },
  mmddyyyy_slash: {
    dateFns: 'MM/dd/yyyy',
    placeholder: 'MM/DD/YYYY',
    cleave: {
      date: true,
      delimiter: '/',
      datePattern: ['m', 'd', 'Y'],
    },
  },
  mmddyyyy_dash: {
    dateFns: 'MM-dd-yyyy',
    placeholder: 'MM-DD-YYYY',
    cleave: {
      date: true,
      delimiter: '-',
      datePattern: ['m', 'd', 'Y'],
    },
  },
  ddmmyyyy_slash: {
    dateFns: 'dd/MM/yyyy',
    placeholder: 'DD/MM/YYYY',
    cleave: {
      date: true,
      delimiter: '/',
      datePattern: ['d', 'm', 'Y'],
    },
  },
  ddmmyyyy_dash: {
    dateFns: 'dd-MM-yyyy',
    placeholder: 'DD-MM-YYYY',
    cleave: {
      date: true,
      delimiter: '-',
      datePattern: ['d', 'm', 'Y'],
    },
  },
  yyyymmdd_slash: {
    dateFns: 'yyyy/MM/dd',
    placeholder: 'YYYY/MM/DD',
    cleave: {
      date: true,
      delimiter: '/',
      datePattern: ['Y', 'm', 'd'],
    },
  },
  yyyymmdd_dash: {
    dateFns: 'yyyy-MM-dd',
    placeholder: 'YYYY-MM-DD',
    cleave: {
      date: true,
      delimiter: '-',
      datePattern: ['Y', 'm', 'd'],
    },
  },
};

export { FORMATS };

export default FORMATS_CONFIG;
